import { ListItemWithAssetSchema } from 'cms/schemaTypes/staticPages/objects/listItemWithAsset'

import HowItWorksStep from './HowItWorksStep'
import { Section } from './Section'
import { SectionContainer } from './SectionContainer'
import SectionTitle from './SectionTitle'

import styles from './RewardsProgramCampaignSectionHowItWorks.module.scss'

const MAX_STEPS = 8

const RewardsProgramCampaignSectionHowItWorks = ({
  campaignPrizeList
}: {
  campaignPrizeList: ListItemWithAssetSchema[]
}) => {
  return (
    <Section $padding='none'>
      <SectionContainer className={styles.sectionContainer}>
        <SectionTitle>
          Rób zakupy na LokalnyRolnik.pl i{' '}
          <span className={styles.markedText}>odbieraj prezenty</span>
        </SectionTitle>
        <div className={styles.stepsWrapper}>
          {campaignPrizeList.slice(0, MAX_STEPS).map((item, index) => (
            <HowItWorksStep
              key={item.key}
              item={item}
              imageLeft={index % 2 === 0}
              stepNumber={index + 1}
            />
          ))}
        </div>
      </SectionContainer>
    </Section>
  )
}

export default RewardsProgramCampaignSectionHowItWorks
